"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var GoogleMaps = function (_a) {
    var embedUrl = _a.embedUrl, attributes = _a.attributes, isPrintMode = _a.isPrintMode, width = _a.width;
    if (!embedUrl) {
        return null;
    }
    if (isPrintMode) {
        return printMapsPlaceholder(width);
    }
    return (React.createElement("figure", null,
        React.createElement("div", { style: attributes.style, className: (0, classnames_1.default)(attributes.className, "embed-widget__container") },
            React.createElement("div", { className: "embed-widget__iframe-container" },
                React.createElement("iframe", { src: embedUrl, title: "Google Maps", frameBorder: "0", allowFullScreen: true, className: "embed-widget__iframe" })))));
};
var printMapsPlaceholder = function (width) {
    var wrapperWidth = 100;
    var wrapperPaddingBottom = 55;
    var fontSizePx = 15;
    var iconWidthPx = 50;
    var marginBottomPx = 15;
    if (width && typeof width === "number") {
        fontSizePx *= width / 100;
        iconWidthPx *= width / 100;
        marginBottomPx *= width / 100;
        wrapperWidth *= width / 100;
        wrapperPaddingBottom *= width / 100;
    }
    var wrapperStyle = "width: ".concat(wrapperWidth, "%; height: 0; padding-bottom: ").concat(wrapperPaddingBottom, "%;");
    return (React.createElement("div", { className: "embedded-content", dangerouslySetInnerHTML: {
            __html: "\n      <div class=\"print-placeholder avoid-page-break\" style=\"".concat(wrapperStyle, "\">\n        <div class=\"print-background\">\n          <!-- Show a generic background 'cloud' if we were unable to get a url for an image thumbnail -->\n          <img class=\"cloud\" src=\"/Public/Assets/Images/cloud-bg.svg\"/>\n        </div>\n        <div class=\"print-message\">\n          <img\n            class=\"offline-icon\"\n            src=\"/Public/Assets/icons/offline-grey.svg\"\n            style=\"width: ").concat(iconWidthPx, "px; margin-bottom: ").concat(marginBottomPx, "px;\"\n          />\n          <div class=\"description\" style=\"font-size: ").concat(fontSizePx, "px;\">Google maps content can't be viewed offline</div>\n        </div>\n      </div>\n  "),
        } }));
};
exports.default = GoogleMaps;
